import React, { useMemo } from "react";
import { Box } from "@mui/material";
import { ResponsivePie } from "@nivo/pie";
import { theme } from "../../theme/theme";
import { PieWrap, PieLegend, PieLegendRow, PieLegendDot, PieLegendLabel, PieLegendValue } from "./PieCharts.elements";

const PieChart = (props) => {
    const totalValue = props.data.reduce((acc, item) => acc + (Number(item.value) || 0), 0);
    const isAllZero = props.data.every((item) => (Number(item.value) || 0) === 0);

    const legendItems = useMemo(() => {
        if (!totalValue) return [];
        return props.data.map((item) => {
            const v = Number(item.value) || 0;
            const pct = totalValue ? Math.round((v / totalValue) * 100) : 0;
            return {
                id: item.id,
                label: item.label,
                color: item.color,
                pct,
            };
        });
    }, [props.data, totalValue]);

    if (isAllZero) return <PieWrap />;

    return (
        <PieWrap>
            <Box sx={{ width: "100%", height: 240, minWidth: 0 }}>
                <ResponsivePie
                    data={props.data}
                    colors={{ datum: "data.color" }}
                    margin={{ top: 10, right: 10, bottom: 10, left: 10 }}
                    innerRadius={0.72}
                    activeOuterRadiusOffset={6}
                    enableArcLinkLabels={false}
                    enableArcLabels={false}
                    borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
                    theme={{
                        tooltip: { container: { color: "#000" } },
                    }}
                />
            </Box>

            <PieLegend>
                {legendItems.map((it) => (
                    <PieLegendRow key={it.id}>
                        <PieLegendLabel>
                            <PieLegendDot style={{ backgroundColor: it.color }} />
                            {it.label}
                        </PieLegendLabel>
                        <PieLegendValue>{it.pct}%</PieLegendValue>
                    </PieLegendRow>
                ))}
            </PieLegend>
        </PieWrap>
    );
};

export default PieChart;
